import getValueOutput from "./get-value-output";

/**
 *
 * @param {PropertyValueProps} item
 * @param {PropertyValueProps} last
 * @param {Number} progress
 * @param {String} current
 * @param {Number | null} index
 * @returns
 */
const getSingleComputedString = (item, last, progress, current, index) => {
  const lastIsCalc = last.get("v_is-calc");
  const prev = getValueOutput(last, index, lastIsCalc);
  const lastComputed = last.get("last-computed");
  const computed = `${lastComputed} - (${progress} * (${prev} - ${current}))`;

  item.set("last-computed", computed);

  return `${lastComputed} - (${progress} * (${prev} - ${current}))`;
};

export default getSingleComputedString;
